import { Outlet } from 'react-router-dom';
import { useBanner } from 'src/hooks/useBanner';
import classNames from 'classnames';
import styles from './AddOnPage.module.scss';

export const AddOnPage = () => {
  const { bannersSet } = useBanner();

  return (
    <div
      className={classNames(styles.root, {
        [styles.reducedHeight]: bannersSet.length !== 0,
      })}
    >
      <Outlet />
    </div>
  );
};
